import BatchColumn from './BatchColumn';
import Title from '../../microComponents/elements/Title';
import ComponentCard from '../../microComponents/elements/ComponentCard';
import CreatorTable from '../../microComponents/tablePages/CreatorTable';
import AddBatch from './AddBatch';
import React from "react";
import ExpandedBatch from "./ExpandedBatch";
import {useNavigate} from "react-router-dom";


const Batch = () => {
    const [columns] = BatchColumn();
    const navigate = useNavigate();

    return (<div>
            <ComponentCard>
                <div className='flex justify-between'>
                    <Title>بچ</Title>
                    <div className='flex gap-2 items-center'>
                        <AddBatch/>
                    </div>
                </div>
            </ComponentCard> <ComponentCard>

            <CreatorTable columns={columns}  expandable={{
                expandedRowRender: (row) => (

                    <ExpandedBatch item={row}/>

                ),
            }}
                          onDoubleClickRowHandler={(row) => {

                              navigate(`/PalletStatus?batchNumber=${row.batchNumber}`);

                          }}
                          listAddress='Batch/Production-Line'
            />


        </ComponentCard></div>
    );
};


export default Batch;